import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

// Lọc lịch phân ca
export function locLichPhanCa(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/cham-cong/lich-lam-viec/', { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy lịch phân ca
export function layLichPhanCa(id: number) {
  try {
    return axiosApi.get('/cham-cong/lich-lam-viec/' + id)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo lịch phân ca
export function taoLichPhanCa(params: any) {
  try {
    return axiosApi.post('/cham-cong/lich-lam-viec/', params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo lịch phân ca hàng loạt
export function taoLichPhanCaHangLoat(params: any) {
  try {
    return axiosApi.post('/cham-cong/lich-lam-viec/tao-hang-loat', params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật lịch phân ca
export function capNhatLichPhanCa(id: number, params: any) {
  try {
    return axiosApi.put('/cham-cong/lich-lam-viec/' + id, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa lịch phân ca
export function xoaLichPhanCa(id: number) {
  try {
    return axiosApi.delete('/cham-cong/lich-lam-viec/' + id)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy lịch phân ca nhân viên
export function layLichPhanCaNhanVien(userId: number, querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/cham-cong/lich-lam-viec/nhan-vien/' + userId, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy lịch phân ca phòng ban
export function layLichPhanCaPhongBan(departmentId: number, querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/cham-cong/lich-lam-viec/phong-ban/' + departmentId, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
